import { useState } from 'react';
import './Footer.css';
import { CurrentUser } from '../login/CurrentUser';
import useSocketClientStatus from '../hooks/useSocketClientStatus';
import useSocketClientInfo from '../hooks/useSocketClientInfo';
import useSocketStatus from '../hooks/useSocketStatus';


export default function Footer() {
    let [user, setUser] = useState("Aguardando login...");

    let status = useSocketClientStatus();
    let machineInfo = useSocketClientInfo();     

    CurrentUser.UpdateFooter = async (user) => {
        if (user)
            setUser(`${user.Name} | ${user.Licence.Number}`);        
    }

    return (
        <footer>
            <p>{user}</p>            
            <p> <i className={`status-icon pi ${status? "pi-link pulsing-connection-online" : "pi-ban non-connection-offline"}`}></i>
                <span className='Status-Info'>{status ? `Estação: ${machineInfo.Machine}` : "Usando cache de dados"}</span></p>
        </footer>
    )
}